import BaseService from "./_base.service";
import { History } from "../models/history";
import { AxiosResponse } from "axios";
import API from "../api";

const endpoint = "folders";

const JobFolderService = {
  async getByJobId(id: number | string): Promise<AxiosResponse<any>> {
    return await API.get(`${endpoint}/job/${id}`);
  },
};

export default JobFolderService;
